<script setup>
import { ref } from "vue";
import http from "@/axios-config";
import router from "@/router";

const password = ref(null);
const confirmPassword = ref(null);
const has_error = ref(false);
const api_error = ref(false);

async function reset() {
    if (password.value != confirmPassword.value) {
        has_error.value = true;
        return;
    }

    http
        .post(`/api/auth/new-password`, {
            link: router.currentRoute.value.params.link,
            password: password.value,
        })
        .then((res) => {
            has_error.value = false;
            router.push({ name: "login" });
        })
        .catch((error) => {
            api_error.value = true;
        });
}
</script>

<template>
    <div class="login" style="background-image: url('/img/login-bg.png')">
        <div class="login-form">
            <h1 class="welcome-message">
                <span class="first-line">New Password</span>
            </h1>
            <div v-if="has_error">
                <p class="error-message">Please make sure your passwords match.</p>
            </div>
            <div v-if="api_error">
                <p class="error-message">
                    Your reset link has expired. Please request a new link.
                </p>
            </div>
            <form autocomplete="off" @submit.prevent="reset" method="post">
                <div class="login-email">
                    <label for="email">Password</label>
                    <input type="password" v-model="password" required />
                </div>
                <div class="login-email">
                    <label for="email">Confirm Password</label>
                    <input type="password" v-model="confirmPassword" required />
                </div>
                <button class="login-submit" type="submit">Confirm Password</button>
            </form>
        </div>
    </div>
</template>

<style scoped lang="scss">
.login {
    background-size: cover;
    background-repeat: no-repeat;
}

.login-form {
    @media (max-width:600px) {
        width: 100%;

        h1 {
            padding: 0 20px;
        }
    }
}
</style>
